import { MARKETING_URL, VERSION_DISPLAY } from '../../lib/env';
import { COMPANY_LEGAL } from '../../lib/company';

type AppBrandFooterProps = {
  className?: string;
};

export function AppBrandFooter({ className = '' }: AppBrandFooterProps) {
  return (
    <div className={`text-center ${className}`.trim()}>
      <p className="text-[11px] text-gray-400 dark:text-gray-500">Coordal Maps v{VERSION_DISPLAY}</p>
      <p className="text-[11px] text-gray-400 dark:text-gray-500">
        Made with Love by the{' '}
        <a
          href={`${MARKETING_URL}/about`}
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary-500 dark:hover:text-primary-400 transition-colors"
        >
          Coordal Team
        </a>
      </p>
      <p className="mt-1 text-[10px] leading-relaxed text-gray-400/90 dark:text-gray-500/90">
        {COMPANY_LEGAL.name}
        <br />
        {COMPANY_LEGAL.address}
        <br />
        {COMPANY_LEGAL.gpsCode} · Reg. No. {COMPANY_LEGAL.registrationNumber}
      </p>
    </div>
  );
}
